;(() => {
  window.SWATCHES_CACHE = window.SWATCHES_CACHE || {}
  window.SWATCHES_LOADING = window.SWATCHES_LOADING || new Set()
  window.SWATCHES_FAILED = window.SWATCHES_FAILED || new Set()
  let currentVariant = null,
    originalTitle = '',
    originalTagline = ''
  ;(originalTitle = ''), (originalTagline = '')

  const STORAGE_KEY = 'lilac_selected_variants'

  localStorage.removeItem(STORAGE_KEY)

  if (!customElements.get('product-swatches-collection')) {
    class ProductSwatchesCollection extends HTMLElement {
      constructor() {
        super()
        this.buttons = this.querySelectorAll('button[data-swatch-url]')
        this.init()
        document.addEventListener('product:variant:change', this.saveSelectedVariant.bind(this))

        this.observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              this.buttons = this.querySelectorAll('button[data-swatch-url]')
              this.initializeActiveSwatch()
            }
          })
        })

        this.observer.observe(this, { childList: true, subtree: true })

        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) {
            requestAnimationFrame(() => this.initializeActiveSwatch())
          }
        })

        window.addEventListener('popstate', () => {
          requestAnimationFrame(() => this.initializeActiveSwatch())
        })
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect()
        }
      }

      init() {
        const titleElement = document.querySelector('.product-collection-title')
        const taglineElement = document.querySelector('.product-collection-tagline')

        if (titleElement) {
          originalTitle = titleElement.textContent.trim()
        }
        if (taglineElement) {
          originalTagline = taglineElement.textContent.trim()
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.initializeActiveSwatch()
          })
        } else {
          this.initializeActiveSwatch()
        }

        this.preloadSwatchLayouts()

        this.setEventListeners()
      }

      preloadSwatchLayouts() {
        const urlsToPreload = []

        this.buttons.forEach((button) => {
          const url = button.getAttribute('data-swatch-url')
          const mappedUrl = button.getAttribute('data-mapped-url')

          if (url) {
            const fullUrl = url.startsWith('/') ? url : `/products/${url}`
            urlsToPreload.push(fullUrl)
          }
          if (mappedUrl && mappedUrl !== url) {
            const fullMappedUrl = mappedUrl.startsWith('/') ? mappedUrl : `/products/${mappedUrl}`
            urlsToPreload.push(fullMappedUrl)
          }
        })

        urlsToPreload.forEach((url, index) => {
          setTimeout(() => {
            this.aggressivePreload(url)
          }, index * 25)
        })
      }

      async aggressivePreload(url, retryCount = 0) {
        const maxRetries = 3

        if (
          window.SWATCHES_CACHE[url] ||
          window.SWATCHES_LOADING.has(url) ||
          (window.SWATCHES_FAILED.has(url) && retryCount >= maxRetries)
        ) {
          return window.SWATCHES_CACHE[url]
        }

        window.SWATCHES_LOADING.add(url)

        try {
          const result = await this.getProductLayoutWithRetry(url, retryCount)
          window.SWATCHES_LOADING.delete(url)
          window.SWATCHES_FAILED.delete(url)
          return result
        } catch (error) {
          window.SWATCHES_LOADING.delete(url)

          if (retryCount < maxRetries) {
            const delay = Math.pow(2, retryCount) * 1000
            setTimeout(() => {
              this.aggressivePreload(url, retryCount + 1)
            }, delay)
          } else {
            window.SWATCHES_FAILED.add(url)
          }
        }
      }

      saveSelectedVariant(evt) {
        currentVariant = evt.detail.variant
      }

      setEventListeners() {
        this.buttons.forEach((button) => {
          button.addEventListener('click', this.onSwatchClick.bind(this))
        })

        document.addEventListener('change', (e) => {
          if (e.target.matches('input[type="radio"][data-hook="product-option"]')) {
            const optionName = e.target.name
            const optionValue = e.target.value

            const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
            stored[optionName] = optionValue
            localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
          }
        })

        this.initializeStorage()
      }

      initializeActiveSwatch() {
        const currentUrl = window.location.href
        const currentProductHandle = this.getCurrentProductHandle()

        this.buttons.forEach((button) => {
          const li = button.closest('li')
          if (li) {
            li.classList.remove('on')
            button.setAttribute('aria-pressed', 'false')
          }
        })

        let activeSwatchFound = false

        this.buttons.forEach((button) => {
          const url = button.getAttribute('data-swatch-url')
          const mappedUrl = button.getAttribute('data-mapped-url')
          const productId = button.getAttribute('data-product-id')
          const shouldUseMapped = currentUrl.includes('3-pack')
          const finalUrl = shouldUseMapped ? mappedUrl : url

          const productHandle = finalUrl?.split('/products/')[1]?.split('?')[0]

          const isActive = productHandle === currentProductHandle

          const li = button.closest('li')
          if (li) {
            if (isActive) {
              li.classList.add('on')
              button.setAttribute('aria-pressed', 'true')
              activeSwatchFound = true
            } else {
              li.classList.remove('on')
              button.setAttribute('aria-pressed', 'false')
            }
          }
        })

        if (!activeSwatchFound && this.buttons.length > 0) {
          const firstButton = this.buttons[0]
          const firstLi = firstButton.closest('li')
          if (firstLi) {
            firstLi.classList.add('on')
            firstButton.setAttribute('aria-pressed', 'true')
          }
        }
      }

      getCurrentProductHandle() {
        const url = window.location.href

        const urlParams = new URLSearchParams(window.location.search)
        const productQuery = urlParams.get('product_query')
        if (productQuery) {
          if (productQuery.match(/^\d+$/)) {
            return this.findProductHandleById(productQuery)
          } else {
            return productQuery
          }
        }

        const productMatch = url.match(/\/products\/([^\/\?]+)/)
        if (productMatch) {
          return productMatch[1]
        }

        const productJson = document.querySelector('[data-hook="product-json"]')
        if (productJson) {
          try {
            const productData = JSON.parse(productJson.textContent)
            return productData.handle
          } catch (e) {}
        }

        return null
      }

      findProductHandleById(productId) {
        const matchingButton = Array.from(this.buttons).find((button) => {
          const buttonProductId = button.getAttribute('data-product-id')
          return buttonProductId === productId
        })

        if (matchingButton) {
          const url = matchingButton.getAttribute('data-swatch-url')
          const mappedUrl = matchingButton.getAttribute('data-mapped-url')
          const shouldUseMapped = window.location.href.includes('3-pack')
          const finalUrl = shouldUseMapped ? mappedUrl : url
          return finalUrl?.split('/products/')[1]?.split('?')[0]
        }

        return null
      }

      initializeStorage() {
        const stored = localStorage.getItem(STORAGE_KEY)
        if (!stored) {
          const selections = {}
          const radioInputs = document.querySelectorAll('input[type="radio"][data-hook="product-option"]:checked')
          radioInputs.forEach((radio) => {
            selections[radio.name] = radio.value
          })
          localStorage.setItem(STORAGE_KEY, JSON.stringify(selections))
        }
      }

      async onSwatchClick(event) {
        const button = event.currentTarget

        const isActive = button.closest('li.on')
        if (isActive) {
          return
        }

        button.classList.add('loading')
        button.disabled = true

        document.querySelectorAll('li.on').forEach((li) => li.classList.remove('on'))

        const clickedLi = button.closest('li')
        if (clickedLi) {
          clickedLi.classList.add('on')
        }

        const url = button.getAttribute('data-swatch-url')
        const mappedUrl = button.getAttribute('data-mapped-url')
        const shouldUseMapped = window.location.href.includes('3-pack')
        const finalUrl = shouldUseMapped ? mappedUrl : url

        const productHandle = finalUrl.split('/products/')[1]?.split('?')[0]

        const productId = button.getAttribute('data-product-id')

        if (productId) {
          this.updateUrlWithProduct(productId)
        }

        const productSection = document.querySelector('[data-main-product]')
        const reviewsSection = document.getElementById('stamped-main-widget')

        const originalDropdownOptions = this.getDropdownOptions()

        const storedSelections = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')

        try {
          let [newProductLayout, newReviewsLayout] = await this.getProductLayoutWithRetry(finalUrl, 0)

          const tempDiv = document.createElement('div')
          tempDiv.innerHTML = newProductLayout

          const currentSection = document.querySelector('[data-product-collection]')
          const currentSettings = JSON.parse(currentSection?.getAttribute('data-section-settings') || '{}')

          if (currentSettings.persistent_title && originalTitle) {
            const titleElement = tempDiv.querySelector('.product-collection-title')
            if (titleElement) {
              titleElement.textContent = originalTitle
            }
          }

          if (currentSettings.persistent_tagline && originalTagline) {
            const taglineElement = tempDiv.querySelector('.product-collection-tagline')
            if (taglineElement) {
              taglineElement.textContent = originalTagline
            }
          }

          const newSection = tempDiv.querySelector('[data-product-collection]')
          if (newSection) {
            newSection.setAttribute('data-persistent-title', currentSettings.persistent_title || 'false')
            newSection.setAttribute('data-persistent-tagline', currentSettings.persistent_tagline || 'false')
            newSection.setAttribute('data-section-settings', JSON.stringify(currentSettings))
          }

          const savedTab = window.lilacGetSubPurchaseTab?.()
          if (savedTab && window.lilacApplySubPurchaseTab) {
            tempDiv.querySelectorAll('.sub-purchase-tabs').forEach((root) => {
              window.lilacApplySubPurchaseTab(root, savedTab)
            })
          }

          newProductLayout = tempDiv.innerHTML

          productSection.outerHTML = newProductLayout
          if (reviewsSection && newReviewsLayout) {
            reviewsSection.outerHTML = newReviewsLayout
          }

          this.restoreDropdownOptions(originalDropdownOptions, productHandle)

          this.reinitializeActiveSwatch(productHandle)

          if (typeof StampedFn !== 'undefined') {
            StampedFn.reloadUGC()
          }
          if (typeof window.setFormListeners === 'function') {
            window.setFormListeners()
          }

          const priceElements = document.querySelectorAll('[data-hook="product-price"]')
          priceElements.forEach((priceElement) => {
            priceElement.dispatchEvent(new CustomEvent('price:reinitialize'))
          })

          requestAnimationFrame(() => {
            const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
            this.restoreSelectedProductOptions(stored)
            window.lilacRestoreSubPurchaseTabs?.({ emitChange: true })
          })
        } catch (error) {
          button.classList.remove('loading')
          button.disabled = false
          if (clickedLi) {
            clickedLi.classList.remove('on')
          }
        } finally {
          button.classList.remove('loading')
          button.disabled = false
        }
      }

      getDropdownOptions() {
        const dropdown = document.querySelector('[data-product-selector]')
        if (!dropdown) return null

        return Array.from(dropdown.options).map((option) => ({
          value: option.value,
          text: option.textContent.replace(' 3-Pack', ''),
          url: option.getAttribute('data-product-url'),
          layout: option.layout,
          selected: option.selected,
        }))
      }

      restoreDropdownOptions(originalOptions, selectedHandle) {
        if (!originalOptions) return

        const newDropdown = document.querySelector('[data-product-selector]')
        if (newDropdown) {
          newDropdown.innerHTML = ''

          originalOptions.forEach((optionData) => {
            const option = document.createElement('option')
            option.value = optionData.value
            option.textContent = optionData.text.replace(' 3-Pack', '')
            option.setAttribute('data-product-url', optionData.url)
            option.selected = optionData.selected // Preserve the original dropdown selection
            option.layout = optionData.layout
            newDropdown.appendChild(option)
          })
        }
      }

      async getProductLayout(url) {
        return this.getProductLayoutWithRetry(url, 0)
      }

      async getProductLayoutWithRetry(url, retryCount = 0) {
        if (window.SWATCHES_CACHE[url]) return window.SWATCHES_CACHE[url]

        const timeout = 10000 + retryCount * 5000 // Increase timeout with retries
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), timeout)

        try {
          const productHandle = url.split('/products/')[1]?.split('?')[0]

          const sectionUrl = `${url}?section_id=product-main-collection&product_query=${productHandle}`

          const [sectionResponse, productResponse] = await Promise.all([
            fetch(sectionUrl, {
              signal: controller.signal,
              headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
              },
            }),
            fetch(url, {
              signal: controller.signal,
              headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
              },
            }),
          ])

          clearTimeout(timeoutId)

          if (!sectionResponse.ok || !productResponse.ok) {
            throw new Error(`HTTP ${sectionResponse.status} / ${productResponse.status}`)
          }

          const [sectionHtml, productHtml] = await Promise.all([sectionResponse.text(), productResponse.text()])

          const productDom = new DOMParser().parseFromString(productHtml, 'text/html')
          const reviewsSection = productDom.getElementById('stamped-main-widget')

          window.SWATCHES_CACHE[url] = [sectionHtml, reviewsSection?.outerHTML || '']
          return window.SWATCHES_CACHE[url]
        } catch (error) {
          clearTimeout(timeoutId)

          if (retryCount < 2 && (error.name === 'AbortError' || error.message.includes('HTTP'))) {
            await new Promise((resolve) => setTimeout(resolve, 1000 * (retryCount + 1)))
            return this.getProductLayoutWithRetry(url, retryCount + 1)
          }

          throw error
        }
      }

      restoreSelectedProductOptions(selectedOptions) {
        if (!selectedOptions || Object.keys(selectedOptions).length === 0) return

        Object.keys(selectedOptions).forEach((optionName) => {
          const selectedValue = selectedOptions[optionName]

          const allRadios = document.querySelectorAll(
            `[data-component="product/buy-panel"] input[type="radio"][data-hook="product-option"]`
          )

          let valueExists = false
          let valueAvailable = false

          allRadios.forEach((radio) => {
            if (radio.name === optionName && radio.value === selectedValue) {
              valueExists = true
              if (!radio.classList.contains('disabled') && !radio.disabled) {
                valueAvailable = true
              }
            }
          })

          if (valueExists && valueAvailable) {
            allRadios.forEach((radio) => {
              if (radio.name === optionName && radio.value === selectedValue) {
                radio.checked = true

                radio.dispatchEvent(new Event('change', { bubbles: true }))
              }
            })
          } else if (valueExists && !valueAvailable) {
            const availableRadios = Array.from(allRadios).filter(
              (radio) => radio.name === optionName && !radio.classList.contains('disabled')
            )

            if (availableRadios.length > 0) {
              const fallbackRadio = availableRadios[0]
              fallbackRadio.checked = true
              fallbackRadio.dispatchEvent(new Event('change', { bubbles: true }))
            }
          }
        })
      }

      reinitializeActiveSwatch(targetProductHandle) {
        document.querySelectorAll('li.on').forEach((li) => li.classList.remove('on'))
        document.querySelectorAll('button[data-swatch-url]').forEach((button) => {
          button.setAttribute('aria-pressed', 'false')
        })

        const newSwatches = document.querySelectorAll('button[data-swatch-url]')
        newSwatches.forEach((button) => {
          const url = button.getAttribute('data-swatch-url')
          const mappedUrl = button.getAttribute('data-mapped-url')
          const shouldUseMapped = window.location.href.includes('3-pack')
          const finalUrl = shouldUseMapped ? mappedUrl : url
          const handle = finalUrl?.split('/products/')[1]?.split('?')[0]

          if (handle === targetProductHandle) {
            const li = button.closest('li')
            if (li) {
              li.classList.add('on')
              button.setAttribute('aria-pressed', 'true')
            }
          }
        })
      }

      updateUrlWithProduct(productHandle) {
        const url = new URL(window.location)
        url.searchParams.set('product_query', productHandle)
        window.history.replaceState({}, '', url)

        requestAnimationFrame(() => this.initializeActiveSwatch())
      }
    }

    customElements.define('product-swatches-collection', ProductSwatchesCollection)
  }
})()
